import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { OpeningHook } from '../components/OpeningHook';
import { ProblemSection } from '../components/ProblemSection';
import { WhyFailed } from '../components/WhyFailed';
import { MechanismSection } from '../components/MechanismSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { TargetAudience } from '../components/TargetAudience';
import { HowItWorks } from '../components/HowItWorks';
import { FAQ } from '../components/FAQ';
import { OfferCTA } from '../components/OfferCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <main className="min-h-screen bg-dark-bg text-white overflow-x-hidden selection:bg-gold selection:text-dark-bg" data-id="element-188">
      <HeroSection data-id="element-189" />
      <OpeningHook data-id="element-190" />
      <ProblemSection data-id="element-191" />
      <WhyFailed data-id="element-192" />
      <MechanismSection data-id="element-193" />
      <BenefitsSection data-id="element-194" />
      <TargetAudience data-id="element-195" />
      <HowItWorks data-id="element-196" />
      <FAQ data-id="element-197" />
      <OfferCTA data-id="element-198" />
      <Footer data-id="element-199" />
    </main>;
}